/* @flow */
import Container from 'components/Container';
import Footer from 'components/Footer';
import PropTypes from 'prop-types';
import * as React from 'react';
import cx from 'classnames';
import './styles/UnauthenticatedView.scss';

class UnauthenticatedView extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    title: PropTypes.node,
  };

  render() {
    const { title, className, children } = this.props;

    return (
      <div>
        <main className={cx('UnauthenticatedView', className)}>
          <Container>
            {title && <h1 className="UnauthenticatedView-title">{title}</h1>}
            {children}
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

export default UnauthenticatedView;
